<template>
   <div class="back-box">
    <div class="back-btn" @click="onBack">
        <i class="el-icon-arrow-left"></i>
    </div>
    <div class="back-title">{{title}}</div>
    <div class="back-help">
    </div>
   </div>
</template>

<script>
export default {
  name: 'BackComponent',
  props: {
     to:{
       types: String,
       default: ''
     },
     title: {
        types: String,
        default: '909数码'
     }
   },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    onBack () {
      if (this.to) {
        this.$router.push({name: this.to})
      } else {
        this.$router.back(-1)
      }
      this.$emit('back')
    },
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.back-box {
  padding-top: 8px;
  padding-left: 5px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .back-btn,.back-help {
    width: 50px;
  }
  .back-btn {
    font-size: 18px;
    font-weight: bold;
  }
  .back-title {
    font-size: 16px;
  }
}
</style>
